import styled from "styled-components";

export const Container = styled.div<{ isWatch?: boolean }>`
  width: 157px;
  height: ${({ isWatch }) => (isWatch ? "228px" : "312px")};
  border-radius: 16px;
  background-color: white;
  position: relative;
  z-index: 99;
  cursor: pointer;
  flex-grow: 0; /* Prevents child from expanding */
  flex-shrink: 0; /* Prevents shrinking */
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px;
  row-gap: 12px;
  position: relative;
`;

export const Chip = styled.div<{ bgColor: string; color?: string }>`
  position: relative;
  align-self: flex-start;
  padding: 5px 6px 3px 6px;
  width: max-content;
  border-radius: 4px;
  background-color: ${({ bgColor }) => bgColor || "#0397C9"};
  font-family: Gilroy;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  color: ${({ color }) => color || "white"};
  line-height: 11px;

  @media screen and (min-width: 768px) {
    font-size: 13px;
  }
`;

export const ImageBadgeCity = styled.img<{ grayScale: boolean }>`
  width: 64px;
  height: 52px;
  filter: ${(props) => (props.grayScale ? "grayscale(1)" : "none")};

  @media screen and (min-width: 769px) {
    width: 80px;
    height: 65px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
`;

export const TextCity = styled.p`
  font-family: Gilroy;
  font-size: 18px;
  font-weight: 700;
  color: #1f2d3d;
  text-transform: uppercase;

  @media screen and (min-width: 768px) {
    font-size: 20px;
  }
`;

export const TextDate = styled.p`
  font-family: Gilroy;
  font-size: 12px;
  font-weight: 700;
  color: #6a7481;

  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
`;

export const LocationWrapper = styled.div`
  display: flex;
  column-gap: 6px;
  align-items: center;
  width: 100%;
`;

export const TextLocation = styled.div`
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-family: Gilroy;
  font-size: 11px;
  font-weight: 400;
  color: #6a7481;

  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
`;

export const TextDefault = styled.div`
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-family: Gilroy;
  font-size: 11px;
  font-weight: 400;
  color: #6a7481;
  line-height: 14px;
`;

export const SwooshContainer = styled.div`
  position: absolute;
  z-index: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 180px;

  img {
    border-radius: 16px 16px 0 0;
    width: 100%;
    height: 100%;
  }
`;

export const Button = styled.button<{
  bgColor?: string;
  color?: string;
  borderColor?: string;
}>`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  width: 100%;
  border-radius: 24px;
  height: 32px;
  background-color: ${({ bgColor }) => bgColor || "#00BCF1"};
  border: ${({ borderColor }) => (borderColor ? `1px solid ${borderColor}` : "")};
  color: ${({ color }) => color || "white"};
  font-family: Gilroy;
  font-size: 16px;
  font-weight: 700;

  @media screen and (min-width: 768px) {
    height: 44px;
  }
`;

export const DesktopContainer = styled.div<{ isWatch?: boolean }>`
  width: 325px;
  height: ${({ isWatch }) => (isWatch ? "216px" : "252px")};
  border-radius: 24px;
  background-color: white;
  position: relative;
  z-index: 99;
`;

export const DesktopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
  margin: 0 16px;
`;

export const DesktopHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
`;

export const DesktopBody = styled.div`
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
`;

export const FooterBody = styled.div`
  position: relative;
  z-index: 9;
  margin: 12px 16px;
`;

export const EmptySpace = styled.div<{ height: string }>`
  height: ${({ height }) => height || "40px"};
  background-color: transparent;
`;

export const LineDivider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #f0f2f9;
  margin: 8px 0;
`;
